export const EVENT_PHOTOS = [
  '/STFD-PHOTOS/IMG_6275.jpg',
  '/STFD-PHOTOS/IMG_6276.jpg',
  '/STFD-PHOTOS/IMG_6277.jpg',
  '/STFD-PHOTOS/IMG_6278.jpg',
  '/STFD-PHOTOS/IMG_6279.jpg',
  '/STFD-PHOTOS/IMG_6280.jpg',
  '/STFD-PHOTOS/IMG_6281.jpg',
  '/STFD-PHOTOS/IMG_6282.jpg',
  '/STFD-PHOTOS/IMG_6283.jpg',
  '/STFD-PHOTOS/IMG_6284.jpg',
  '/STFD-PHOTOS/IMG_6286.jpg',
  '/STFD-PHOTOS/IMG_6288.jpg',
  '/STFD-PHOTOS/IMG_6289.jpg',
  '/STFD-PHOTOS/IMG_6291.jpg',
  '/STFD-PHOTOS/IMG_6293.jpg',
  '/STFD-PHOTOS/IMG_6294.jpg',
  '/STFD-PHOTOS/IMG_6295.jpg',
  '/STFD-PHOTOS/IMG_6296.jpg',
  '/STFD-PHOTOS/IMG_6297.jpg',
  '/STFD-PHOTOS/IMG_6298.jpg',
  '/STFD-PHOTOS/IMG_6299.jpg',
  '/STFD-PHOTOS/IMG_6301.jpg',
  '/STFD-PHOTOS/IMG_6302.jpg',
  '/STFD-PHOTOS/IMG_6303.jpg',
  '/STFD-PHOTOS/IMG_6304.jpg',
  '/STFD-PHOTOS/IMG_6305.jpg',
  '/STFD-PHOTOS/IMG_6306.jpg',
  '/STFD-PHOTOS/IMG_6307.jpg',
  '/STFD-PHOTOS/IMG_6308-Edit.jpg',
  '/STFD-PHOTOS/IMG_6310.jpg',
  '/STFD-PHOTOS/IMG_6311.jpg',
  '/STFD-PHOTOS/IMG_6312.jpg',
  '/STFD-PHOTOS/IMG_6314.jpg',
  '/STFD-PHOTOS/IMG_6315.jpg',
  '/STFD-PHOTOS/IMG_6316.jpg',
  '/STFD-PHOTOS/IMG_6317.jpg',
  '/STFD-PHOTOS/IMG_6318.jpg',
  '/STFD-PHOTOS/IMG_6319.jpg',
  '/STFD-PHOTOS/IMG_6320.jpg',
  '/STFD-PHOTOS/IMG_6321.jpg',
  '/STFD-PHOTOS/IMG_6323.jpg',
  '/STFD-PHOTOS/IMG_6324.jpg',
  '/STFD-PHOTOS/IMG_6325.jpg',
  '/STFD-PHOTOS/IMG_6326.jpg',
  '/STFD-PHOTOS/IMG_6327.jpg',
  '/STFD-PHOTOS/IMG_6329.jpg',
  '/STFD-PHOTOS/IMG_6331.jpg',
  '/STFD-PHOTOS/IMG_6332.jpg',
  '/STFD-PHOTOS/IMG_6333.jpg',
  '/STFD-PHOTOS/IMG_6334.jpg',
  '/STFD-PHOTOS/IMG_6335.jpg',
  '/STFD-PHOTOS/IMG_6337.jpg',
  '/STFD-PHOTOS/IMG_6340.jpg',
  '/STFD-PHOTOS/IMG_6341.jpg',
  '/STFD-PHOTOS/IMG_6342.jpg',
  '/STFD-PHOTOS/IMG_6343.jpg',
  '/STFD-PHOTOS/IMG_6344.jpg',
  '/STFD-PHOTOS/IMG_6345.jpg',
  '/STFD-PHOTOS/IMG_6346.jpg',
  '/STFD-PHOTOS/IMG_6349.jpg',
  '/STFD-PHOTOS/IMG_6352.jpg',
  '/STFD-PHOTOS/IMG_6354.jpg',
  '/STFD-PHOTOS/IMG_6355.jpg',
  '/STFD-PHOTOS/IMG_6356.jpg',
  '/STFD-PHOTOS/IMG_6357.jpg',
  '/STFD-PHOTOS/IMG_6359.jpg',
  '/STFD-PHOTOS/IMG_6360.jpg',
  '/STFD-PHOTOS/IMG_6361.jpg',
  '/STFD-PHOTOS/IMG_6362-Edit.jpg',
  '/STFD-PHOTOS/IMG_6365.jpg',
  '/STFD-PHOTOS/IMG_6367.jpg',
  '/STFD-PHOTOS/IMG_6368.jpg',
  '/STFD-PHOTOS/IMG_6376.jpg',
  '/STFD-PHOTOS/IMG_6378.jpg',
  '/STFD-PHOTOS/IMG_6381.jpg',
  '/STFD-PHOTOS/IMG_6382.jpg',
  '/STFD-PHOTOS/IMG_6386.jpg',
  '/STFD-PHOTOS/IMG_6387.jpg',
  '/STFD-PHOTOS/IMG_6388.jpg',
  '/STFD-PHOTOS/IMG_6389.jpg',
  '/STFD-PHOTOS/IMG_6395.jpg',
  '/STFD-PHOTOS/IMG_6397.jpg',
  '/STFD-PHOTOS/IMG_6398.jpg',
  '/STFD-PHOTOS/IMG_6399.jpg',
  '/STFD-PHOTOS/IMG_6400.jpg',
  '/STFD-PHOTOS/IMG_6401.jpg',
  '/STFD-PHOTOS/IMG_6403.jpg',
  '/STFD-PHOTOS/IMG_6404.jpg',
  '/STFD-PHOTOS/IMG_6405.jpg',
  '/STFD-PHOTOS/IMG_6406.jpg',
  '/STFD-PHOTOS/IMG_6407.jpg',
  '/STFD-PHOTOS/IMG_6408.jpg',
  '/STFD-PHOTOS/IMG_6409.jpg',
  '/STFD-PHOTOS/IMG_6410.jpg',
  '/STFD-PHOTOS/IMG_6411.jpg',
  '/STFD-PHOTOS/IMG_6412.jpg',
  '/STFD-PHOTOS/IMG_6413.jpg',
  '/STFD-PHOTOS/IMG_6414.jpg',
  '/STFD-PHOTOS/IMG_6415.jpg',
  '/STFD-PHOTOS/IMG_6416.jpg',
  '/STFD-PHOTOS/IMG_6417.jpg',
  '/STFD-PHOTOS/IMG_6418.jpg',
  '/STFD-PHOTOS/IMG_6419.jpg',
  '/STFD-PHOTOS/IMG_6420.jpg',
  '/STFD-PHOTOS/IMG_6421.jpg',
  '/STFD-PHOTOS/IMG_6422.jpg',
  '/STFD-PHOTOS/IMG_6423.jpg',
  '/STFD-PHOTOS/IMG_6424.jpg',
  '/STFD-PHOTOS/IMG_6425.jpg',
  '/STFD-PHOTOS/IMG_6426.jpg',
  '/STFD-PHOTOS/IMG_6427.jpg',
  '/STFD-PHOTOS/IMG_6428.jpg',
  '/STFD-PHOTOS/IMG_6429.jpg',
  '/STFD-PHOTOS/IMG_6430.jpg',
  '/STFD-PHOTOS/IMG_6431.jpg',
  '/STFD-PHOTOS/IMG_6432.jpg',
  '/STFD-PHOTOS/IMG_6434.jpg',
  '/STFD-PHOTOS/IMG_6435.jpg',
  '/STFD-PHOTOS/IMG_6436.jpg',
  '/STFD-PHOTOS/IMG_6437.jpg',
  '/STFD-PHOTOS/IMG_6439.jpg',
  '/STFD-PHOTOS/IMG_6440.jpg',
  '/STFD-PHOTOS/IMG_6441.jpg',
  '/STFD-PHOTOS/IMG_6442.jpg',
  '/STFD-PHOTOS/IMG_6443.jpg',
  '/STFD-PHOTOS/IMG_6444.jpg',
  '/STFD-PHOTOS/IMG_6447.jpg',
  '/STFD-PHOTOS/IMG_6448.jpg',
  '/STFD-PHOTOS/IMG_6449.jpg',
  '/STFD-PHOTOS/IMG_6450.jpg',
  '/STFD-PHOTOS/IMG_6451.jpg',
  '/STFD-PHOTOS/IMG_6453.jpg',
  '/STFD-PHOTOS/IMG_6454.jpg',
  '/STFD-PHOTOS/IMG_6457.jpg',
  '/STFD-PHOTOS/IMG_6458.jpg',
  '/STFD-PHOTOS/IMG_6459.jpg',
  '/STFD-PHOTOS/IMG_6460.jpg',
  '/STFD-PHOTOS/IMG_6462.jpg',
  '/STFD-PHOTOS/IMG_6463.jpg',
  '/STFD-PHOTOS/IMG_6465.jpg',
  '/STFD-PHOTOS/IMG_6466.jpg',
  '/STFD-PHOTOS/IMG_6467.jpg',
  '/STFD-PHOTOS/IMG_6468.jpg',
  '/STFD-PHOTOS/IMG_6469.jpg',
  '/STFD-PHOTOS/IMG_6470.jpg',
  '/STFD-PHOTOS/IMG_6471.jpg',
  '/STFD-PHOTOS/IMG_6474.jpg',
  '/STFD-PHOTOS/IMG_6475.jpg',
] as const;
